<template>
  <div class="formInputWithButton">
    <div class="formInputWithButton__input">
      <form-field
        :value="value"
        :name="name"
        type="text"
        :placeholder="placeholder"
        is-tall
        @input="onInput"
      />
      <v-button
        :theme="theme"
        :text="isMobile && mobileText ? mobileText : text"
        :class="[
          'formInputWithButton__button',
          { 'formInputWithButton__button--smallPadding': smallPadding },
        ]"
        @click="onClick"
      />
    </div>
  </div>
</template>
<script>
import mobileMixin from '~/mixins/mobile';
import FormField from '~/components/Form/FormField';
import VButton from '~/components/VButton';

export default {
  name: 'FormInputWithButton',
  components: {
    FormField,
    VButton,
  },
  mixins: [mobileMixin(true, 768)],
  props: {
    text: {
      type: String,
      default: 'Dołącz',
    },
    mobileText: {
      type: String,
      default: '',
    },
    smallPadding: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
    theme: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
  },
  methods: {
    onInput(e) {
      this.$emit('input', e);
    },
    onClick(e) {
      this.$emit('click', this.value);
    },
  },
};
</script>
<style lang="scss">
.formInputWithButton {
  $root: &;

  &__input {
    position: relative;
    background: $cWhite;
    border-radius: 4px;

    & input {
      height: 6.8rem;
      background: $cWhite;
      border: none;
      width: 75%;

      @include rwd('ultra') {
        height: 5rem;
      }

      @include rwd('large-laptop', true) {
        max-width: 33rem;
      }

      &::placeholder {
        color: $cMainNeutral;
      }
    }
  }

  &__button {
    position: absolute;
    right: 6px;
    top: 50%;
    transform: translate(0, -50%);
    box-shadow: none;

    @include rwd('ultra') {
      height: 4rem;
    }

    &:hover {
      box-shadow: none;
    }

    &--smallPadding {
      font-size: 1.6rem;
      padding: 0 2.2rem;

      @include rwd('ultra') {
        padding: 0 1.8rem;
      }
    }

    & div {
      @include rwd('large-tablet') {
        display: none;
      }
    }
  }
}
</style>
